<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">{{ title }}部门账号</div>
      <div class="box">
        <div class="form">
          <el-form
            ref="form"
            :rules="rules"
            :model="addeditInfo"
            label-width="160px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门名称" prop="department">
                  <el-input
                    v-model="addeditInfo.department"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="部门账号" prop="username">
                  <el-input
                    v-model="addeditInfo.username"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="负责人姓名">
                  <el-input
                    v-model="addeditInfo.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <div v-if="!id">
                <el-col :span="12">
                  <el-form-item label="联系方式" prop="phone">
                    <el-input
                      v-model="addeditInfo.phone"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门邮箱" prop="email">
                  <el-input
                    v-model="addeditInfo.email"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码" v-if="title === '编辑'">
                  <el-input
                    v-model="addeditInfo.password"
                    show-password
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="密码"
                  prop="password"
                  v-if="title === '新增'"
                >
                  <el-input
                    v-model="addeditInfo.password"
                    show-password
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" v-show="companyList.length > 1">
                <el-form-item label="所属公司" prop="belong_company">
                  <el-select
                    v-model="addeditInfo.belong_company"
                    placeholder="请选择"
                    style="width: 100%; display: inline-block"
                    @change="getRoleData()"
                  >
                    <el-option
                      v-for="(item, index) in companyList"
                      :key="index"
                      :label="item.company_name"
                      :value="item.company_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账户类型" prop="role_id">
                  <el-select
                    v-model="addeditInfo.role_id"
                    placeholder="请选择"
                    style="width: 100%; display: inline-block"
                  >
                    <el-option
                      v-for="(item, index) in roleList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button @click="$router.go(-1)">关闭</el-button>
            <el-button type="primary" @click="submitForm('form')"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoleList, SetUserDeatil, GetUserDeatil } from '@/api/user'
import { isPhone } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { selectCompanyData } from '@/api/company'
import { getRoleData, addAccount, getCompanys, editAccount } from '@/api/user'
let userInfo = JSON.parse(localStorage.getItem('user'))
export default {
  data () {
    return {
      id: null,
      edit: true,
      editPerson: true,
      token: getToken(),
      data: {
        photo: '',
        belong_company: null
      },
      rules: {
        belong_company: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        department: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        phone: [
          // { required: true, message: '请选择', trigger: 'change' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }
        ],
        email: [
          // { required: true, message: '请输入', trigger: 'change' },
          { pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message: '请输入正确邮箱' }
        ],
        role_id: [
          { required: true, message: '请输入', trigger: 'change' }
        ]
      },
      options: {
        roleOptions: [],
        companyOptions: []
      },
      companyData: [],
      userRoleData: [],
      URL: process.env.VUE_APP_BASE_API,
      title: '新增',
      roleList: [],
      addeditInfo: {
        belong_company: '',
        department: '',
        username: '',
        password: '',
        name: '',
        phone: '',
        email: '',
        role_id: '',
        type: 2
      },
      companyList: []

    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.addeditInfo = this.$route.query
      this.addeditInfo.type = 2
      this.addeditInfo.belong_company = parseInt(this.addeditInfo.belong_company)
      this.addeditInfo.role_id = parseInt(this.addeditInfo.role_id) || ''
      this.getRoleData()
      this.title = '编辑'
    } else {
      this.title = '新增'
    }
    // this.getRoleData()
    this.getCompanyData()
    // this.initCompanyData()
  },
  methods: {
    //获取公司
    getCompanyData () {
      getCompanys().then(da => {
        this.companyList = da.data
        if (this.$route.query && this.$route.query.companyId) {
          this.addeditInfo.belong_company = this.$route.query.companyId
        }
        this.getRoleData()
      })
    },
    //获取角色
    getRoleData () {
      let params = {
        companyId: this.addeditInfo.belong_company,
        level: 3
      }
      getRoleData(params)
        .then(res => {
          this.roleList = res.data
          // if (res.code === 0) {
          //   this.queryRoleOptions(res.data)
          // }
        })
    },
    handleAvatarSuccess (res) {
      if (res.code === 0) {
        this.data.photo = res.data.src
      }
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title === '新增') {
            addAccount(this.addeditInfo).then(res => {
              if (res.code == 0) {
                this.$message.success('保存成功!')
                this.$router.back(-1)
              }
            })
          } else {
            if (!this.addeditInfo.password) {
              delete this.addeditInfo.password
            }
            editAccount(this.addeditInfo).then(res => {
              if (res.code == 0) {
                this.$message.success('保存成功!')
                this.$router.back(-1)
              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
        text-align: center;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
          img {
            width: 156px;
            height: 159px;
            display: block;
          }
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        // max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>
